/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Swal from "sweetalert2";
import RichTextEditor from "react-rte";
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
const useStyles = makeStyles(styles);
import SweetAlert from "react-bootstrap-sweetalert";
const useStyleData = makeStyles(stylesData);
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import moment from "moment";
import axios from "../../utils/axiosInstance";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, FormControlLabel } from "@material-ui/core";
const isValidDate = (current) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return current >= now;
};

export default function EditLottery() {
  let fileInput = React.createRef();
  let { lotteryId } = useParams();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [formValues, setFormValues] = React.useState({
    lotteryName: "",
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    instruction: "",
    // maxRpmLotteryWheel: 0,
    decelarationOfLotteryWheel: 20,
    maxNumOfTickets: 0,
    freeTicketSpinData: null,
    totalNoOfFreeTicket: 0,
    freeTicketSpinNumbers: [],
    status: "",
    endDateTime: "",
    drawPrize: [],
    LotteryTypeEvent: "",
    startDateTime: "",
    maxTktPurchLimit: "",
     LotteryTypeEvent: false,
    lastTwoSpinNum: [],
    jackpotSelected: false,
  });
  console.log(
    formValues,

    "formValues"
  );
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedStartTime, setSelectedStartTime] = React.useState(null);
  const [selectedEndTime, setSelectedEndTime] = React.useState(null);
  const [drawDateTime, setDrawDateTime] = React.useState(null);
  const [decelarationOfWheel, setDecelarationOfWheel] = React.useState(60);
  const [rpmOfWheel, setrpmOfWheel] = React.useState(3);
  const [file, setFile] = React.useState(null);
  const [lastTwoTktNumPrice, setLastTwoTktNumPrice] = React.useState(0);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [totalSpin, setTotalSpin] = useState(2);
  const [lastTwoSpinNums, setlastTwoSpinNums] = React.useState(
    Array(totalSpin).fill(0)
  );
  const [avatar, setAvatar] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [imageurl, setImageurl] = React.useState("");
  const [alert, setAlert] = React.useState(null);
  const [editorBody, setEditorBody] = React.useState(
    RichTextEditor.createEmptyValue()
  );
  const [totalDraw, setTotalDraw] = useState(3);
  const [drawPrizes, setDrawPrizes] = React.useState(Array(totalDraw).fill(0));
  const [buttonLoading, setButtonLoading] = React.useState(false);
  const [maxRPM, setMaxRPM] = React.useState(0);
  const [freeTicketSpinNo, setFreeTicketSpinNo] = React.useState([]);
  console.log(freeTicketSpinNo, "freeTicketSpinNo");

  const [freeTicketSpinPrize, setFreeTicketSpinPrize] = React.useState({});
  console.log(freeTicketSpinPrize, "freeTicketSpinPrize");
  const handleDrawChange = (event, index) => {
    const updatedDrawPrizes = [...drawPrizes];
    updatedDrawPrizes[index] = event.target.value;
    setDrawPrizes(updatedDrawPrizes);
    setFormValues({
      ...formValues,
      drawPrize: [...updatedDrawPrizes],
    });
  };


  const handleImageChange = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile(e.target.files[0]);
    setFile(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl(reader.result);
      setImageurl(e.target.files[0]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl);
  };

  const handleRemove = () => {
    setFile(null);
    setImageurl(null);
    setImagePreviewUrl(defaultAvatar);
    fileInput.current.value = null;
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery/${lotteryId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            setSelectedStartTime(
              moment(`2023-11-16T${data.startTime}`).format("hh:mm A")
            );
            setSelectedEndTime(
              moment(`2023-11-16T${data.endTime}`).format("hh:mm A")
            );
            setDrawDateTime(
              moment(`${data.lotteryDrawDate}`).format("YYYY-MM-DD hh:mm A")
            );
            setFormValues({
              lotteryName: data.lotteryName,
              ticketPrice: data.ticketPrice,
              numOfTicketOnSale: data.numOfTicketOnSale,
              ticketCountdown: data.ticketCountdown,
              startDate: data.startDate,
              endDate: data.endDate,
              startTime: data.startTime,
              endTime: data.endTime,
              lotteryDrawDate: data.lotteryDrawDate,
              lotteryDrawTime: data.lotteryDrawTime,
              totalDraw: data.totalDraw,
              instruction: data.instruction,
              maxRpmLotteryWheel: data.maxRpmLotteryWheel,
              decelarationOfLotteryWheel: data.decelarationOfLotteryWheel,
              maxNumOfTickets: data.maxNumOfTickets,
              status: data.status,
              endDateTime: data.endDateTime,
              startDateTime: data.startDateTime,
              freeTicketSpinData: data?.freeTicketSpinData,
              totalNoOfFreeTicket: Object.keys(data?.freeTicketSpinData || {}).length,
              freeTicketSpinNumbers: Object.keys(data?.freeTicketSpinData || {}).map(Number),
              imagePreviewUrl: `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data.image}`,
              maxTktPurchLimit: data.maxTktPurchLimit,
              LotteryTypeEvent: data.LotteryTypeEvent,
              totalSpin: data.lastTwoSpinNum.length,
              jackpotSelected: data.jackpotSelected,
            });
            // setMaxRPM(data.maxRpmLotteryWheel)
            setDrawPrizes((prevState) => [...data.drawPrize]);
            setlastTwoSpinNums([...data.lastTwoSpinNum]);
            setImagePreviewUrl(
              `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data.image}`
            );
          });
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        } else {
          Swal.fire({
            text: error.response.data.message,
          });
        }
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  React.useEffect(() => {
    generateTextFields();
  }, [formValues.totalDraw]);
  React.useEffect(() => {
    generateFreeTicketSpinTextFields();
    generateFreeTicketSpinPrizeFields()
  }, [formValues.totalNoOfFreeTicket]);

  const handleSpinNumberChange = (event, index) => {
    const { value } = event.target;

    setFormValues((prev) => {
      const updated = [...(prev.freeTicketSpinNumbers || [])];
      updated[index] = value === "" ? "" : Number(value) - 1;

      return {
        ...prev,
        freeTicketSpinNumbers: updated,
      };
    });
  };
  const handleSpinPrizeChange = (event, index) => {
    const { value } = event.target;

    setFormValues((prev) => {
      const updatedData = { ...(prev.freeTicketSpinData || {}) };
      updatedData[index] = value === "" ? "" : Number(value);

      return {
        ...prev,
        freeTicketSpinData: updatedData,
      };
    });
  };

  const generateTextFields = () => {
    const textFields = [];
    for (let i = 0; i < formValues.totalDraw; i++) {
      textFields.push(i);
    }
    return textFields.map((index) => (
      <GridItem key={index} xs={12} sm={12} md={3}>
        <CustomInput
          labelText={`Draw Prize ${index + 1}`}
          id={`drawPrize${index}`}
          type="number"
          formControlProps={{
            fullWidth: true,
          }}
          value={drawPrizes[index] || ""}
          handleChange={(event) => handleDrawChange(event, index)}
          inputProps={{
            type: "number",
            value: drawPrizes[index],
          }}
        />
      </GridItem>
    ));
  };
  // console.log(formValues.freeTicketSpinNumbers[index] , "hsgasgjahs")
  const generateFreeTicketSpinTextFields = () => {
    const textFields = [];

    for (
      let i = 0;
      i < formValues.totalNoOfFreeTicket && i <= formValues.totalDraw - 1;
      i++
    ) {
      textFields.push(i);
    }

    return textFields.map((index) => {
      const internalValue = formValues.freeTicketSpinNumbers[index];
      const displayedValue = internalValue !== undefined && internalValue !== ""
        ? internalValue + 1
        : "";

      return (
        <GridItem key={index} xs={12} sm={12} md={3}>
          <CustomInput
            labelText={"Free ticket Spin No."}
            id={`spin${index}`}
            type="number"
            formControlProps={{ fullWidth: true }}
            handleChange={(event) => handleSpinNumberChange(event, index)}
            inputProps={{
              type: "number",
              min: 1,
              value: displayedValue,
            }}
          />
        </GridItem>
      );
    });
  };





  const generateFreeTicketSpinPrizeFields = () => {
    const textFields = [];
    for (let i = 0; i < formValues.totalNoOfFreeTicket && i < formValues.totalDraw; i++) {
      textFields.push(i);
    }
    const prizeValues = Object.values(formValues.freeTicketSpinData || {});
    console.log(prizeValues, "prizeValues");
    return textFields.map((index) => {
      const value = prizeValues[index];
      console.log(value, "value");


      return (
        <GridItem key={index} xs={12} sm={12} md={3}>
          <CustomInput
            labelText={`Free ticket Spin No. prize ${index + 1}`}
            id={`spin${index}`}
            type="number"
            formControlProps={{ fullWidth: true }}
            handleChange={(event) => handleSpinPrizeChange(event, index)}
            inputProps={{
              type: "number",
              value: value ?? "",
              min: 0,
            }}
          />
        </GridItem>
      );
    });

  };
  const handleChangeTotalSpin = (e) => {
    const value = Math.max(0, Number(e.target.value) || 0);
    setFormValues((prev) => ({
      ...prev,
      totalNoOfFreeTicket: value,
    }));
  };
  // const handleChangeTotalSpin = (e) => {
  //     setFormValues({
  //       ...formValues,
  //       [e.target.id]:
  //         e.target.type === "number" ? Number(e.target.value) : e.target.value,
  //     });
  //     console.log("mmm", formValues);
  //     setlastTwoSpinNums([]);
  //   };

  const handleSimple = (e) => {
    setSimpleSelect(e.target.value);
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditorChange = (newValue) => {
    setEditorBody(newValue);
    setFormValues({
      ...formValues,
      instruction: newValue.toString("html"),
    });
  };

  const handleChange = (e) => {
    const { id, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormValues({
      ...formValues,
      [e.target.id]:
        e.target.type === "number" ? Number(e.target.value) : newValue,
    });
    console.log(formValues, "kkk");
  };

  const handleChangeTotalDraw = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]:
        e.target.type === "number" ? Number(e.target.value) : e.target.value,
    });
    console.log(formValues, "lll");
    setDrawPrizes([]);
  };
  React.useEffect(() => {
    if (
      document?.getElementById("maxRpmLotteryWheel") !== null &&
      !document
        ?.getElementById("maxRpmLotteryWheel")
        ?.classList?.contains("noUi-target")
    ) {
      Slider.create(document?.getElementById("maxRpmLotteryWheel"), {
        start: [formValues.maxRpmLotteryWheel],
        tooltips: true,
        connect: [true, false],
        step: 1,
        range: { min: 60, max: 120 },
      }).on("update", (values, handle) => {
        setrpmOfWheel(parseFloat(values[handle]));
        console.log(values);
      });
    }
    if (
      document?.getElementById("maxRpmLotteryWheel") !== null &&
      !document
        ?.getElementById("decelarationOfLotteryWheel")
        ?.classList?.contains("noUi-target")
    ) {
      Slider.create(document?.getElementById("decelarationOfLotteryWheel"), {
        start: [formValues.decelarationOfLotteryWheel],
        connect: [true, false],
        tooltips: true,
        step: 1,
        range: { min: 3, max: 7 },
      }).on("update", (values, handle) => {
        setDecelarationOfWheel(parseFloat(values[handle]));
        console.log(values);
      });
    }
    return function cleanup() { };
  });

  const handleDateTimeChange = (event) => {
    const date = new Date(event._d);
    console.log("Raw Selected Date:", date);
    setSelectedDate(moment(date).format("DD/MM/YYYY"));
    setSelectedStartTime(moment(date).format("hh:mm A"));
    const formattedDate = moment(date).format("YYYY-MM-DD");
    const formattedTime = moment(date).format("HH:mm:ss.SSSZ");
    setFormValues((prev) => ({
      ...prev,
      startDate: formattedDate,
      startTime: formattedTime,
    }));
    console.log("Updated Form Values for API:", {
      startDate: formattedDate,
      startTime: formattedTime,
    });
  };

  const handleEndDateTimeChange = (event) => {
    const date = new Date(event._d);
    console.log("Raw Selected Date:", date);
    setSelectedDate(moment(date).format("DD/MM/YYYY"));
    setSelectedEndTime(moment(date).format("hh:mm A"));
    const formattedDate = moment(date).format("YYYY-MM-DD");
    const formattedTime = moment(date).format("HH:mm:ss.SSSZ");
    setFormValues((prev) => ({
      ...prev,
      endDate: formattedDate,
      endTime: formattedTime,
    }));
    console.log("Updated Form Values for API:", {
      endDate: formattedDate,
      endTime: formattedTime,
    });
  };

  const handleSubmitForm = async (event) => {
    setButtonLoading(true);
    event.preventDefault();
    const token = localStorage.getItem("token");
    setShowLoader(true);
    const formattedData = {
      ...formValues,
      startDate: moment(
        `${formValues.startDate} ${formValues.startTime}`
      ).toISOString(),
      startTime: moment(
        `${formValues.startDate} ${formValues.startTime}`
      ).toISOString(),
      endDate: moment(
        `${formValues.endDate} ${formValues.endTime}`
      ).toISOString(),
      endTime: moment(
        `${formValues.endDate} ${formValues.endTime}`
      ).toISOString(),
    };
    const formData = new FormData();
    for (const key in formattedData) {
      console.log(key);
      if (key === "drawPrize") {
        drawPrizes.forEach((value, index) => {
          formData.append(`${key}[${index}]`, value);
        });
      }

      if (key === "decelarationOfLotteryWheel") {
        formData.append(key, decelarationOfWheel);
      }
      else if (key === "freeTicketSpinData") {
        const values = Object.values(formValues.freeTicketSpinData);
        console.log(values, "sura1");
        const data = formValues.freeTicketSpinNumbers.reduce((acc, key, index) => {
          acc[key] = values[index];
          return acc;
        }, {});
        console.log(data, "sura");
        formData.append("freeTicketSpinData", JSON.stringify(data))
      }
      else {
        formData.append(key, formattedData[key]);
      }
    }
    console.log(formData, "before");
    formData.delete("maxRpmLotteryWheel");
    formData.delete("drawPrize");
    formData.append("maxRpmLotteryWheel", rpmOfWheel);
    formData.append("image", selectedFile);
    // formData.append("decelarationOfLotteryWheel", decelarationOfWheel);
    //const newFormValue= Object.assign(formValues,{"image":imageurl});
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    console.log(formData, "after");
    axios
      .put(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery/` +
        lotteryId,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // 'Content-Type': 'application/json',
            // "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {res.data.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {err?.response?.data?.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
      });
    setButtonLoading(false);
  };

  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/ManageLotteries`);
  };
  const handleLotteryDateTimeChange = (event) => {
    const date = new Date(event._d);
    console.log("drawDate", date);
    setSelectedDate(date.toISOString().split("T")[0]); // Extract date in yyyy-mm-dd format
    setDrawDateTime(moment(date).format("YYYY-MM-DD hh:mm A"));
    setFormValues({
      ...formValues,
      lotteryDrawDate: date.toISOString(),
      lotteryDrawTime: date.toISOString(),
    });
    console.log(formValues);
  };
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  React.useEffect(() => {
    if (formValues.instruction && !initialLoaded) {
      setEditorBody(RichTextEditor.createValueFromString(formValues.instruction, 'html'));
      setInitialLoaded(true);
    }
  }, [formValues.instruction, initialLoaded]);

  return (
    <>
      {loading && <div>Loading</div>}
      {!loading && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Edit Lottery</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={4} md={12}>
                      <legend>Lottery Image</legend>
                      {console.log(imagePreviewUrl, "imageeeeeeeeeeeeeee")}
                      <ImageUpload
                        avatar
                        fileValue={file}
                        imagePreviewUrlValue={imagePreviewUrl}
                        handleImageChange={handleImageChange}
                        handleRemove={handleRemove}
                        addButtonProps={{
                          color: "rose",
                          round: true,
                        }}
                        changeButtonProps={{
                          color: "rose",
                          round: true,
                        }}
                        removeButtonProps={{
                          color: "danger",
                          round: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Lottery Name"
                        id="lotteryName"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues.lotteryName,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Maximum Number Of Tickets"
                        type="number"
                        id="maxNumOfTickets"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        handleChange={handleChange}
                        inputProps={{
                          type: "number",
                          value: formValues.maxNumOfTickets,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        type="number"
                        labelText="Ticket Price"
                        id="ticketPrice"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        handleChange={handleChange}
                        inputProps={{
                          type: "number",
                          value: formValues.ticketPrice,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Number Of Ticket On Sale"
                        type="number"
                        id="numOfTicketOnSale"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        handleChange={handleChange}
                        value={formValues.numOfTicketOnSale}
                        inputProps={{
                          type: "number",
                          value: formValues.numOfTicketOnSale,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        Start Date and Time
                      </InputLabel>
                      <br />

                      <FormControl fullWidth>
                        <Datetime
                          id={"startDate"}
                          value={
                            formValues.startDate && formValues.startTime
                              ? moment
                                .utc(
                                  `${formValues.startDate}T${formValues.startTime}`
                                )
                                .local()
                                .toDate()
                              : null
                          }
                          inputProps={{
                            placeholder: "Start Date",
                            readOnly: true,
                            value:
                              formValues.startDate && formValues.startTime
                                ? moment
                                  .utc(`${formValues.startDate}T${formValues.startTime}`)
                                  .local()
                                  .format("YYYY-MM-DD hh:mm A") // 👉 "2025-09-05 12:00 AM"
                                : "",
                          }}
                          onChange={handleDateTimeChange}
                          isValidDate={isValidDate}
                        />
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        End Date and Time
                      </InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          value={
                            formValues.endDate && formValues.endTime
                              ? moment
                                .utc(
                                  `${formValues.endDate}T${formValues.endTime}`
                                )
                                .local()
                                .toDate()
                              : null
                          }
                          onChange={handleEndDateTimeChange}
                          inputProps={{
                            placeholder: "End Date and Time",
                            value:
                              formValues.endDate && formValues.endTime
                                ? moment
                                  .utc(`${formValues.endDate}T${formValues.endTime}`)
                                  .local()
                                  .format("YYYY-MM-DD hh:mm A") // 👉 "2025-09-05 12:00 AM"
                                : "",
                            readOnly: true,
                          }}
                          isValidDate={isValidDate}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        Lottery Draw Date and Time
                      </InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          value={
                            formValues.lotteryDrawDate &&
                              formValues.lotteryDrawTime
                              ? moment
                                .utc(`${formValues.lotteryDrawDate}`)
                                .local()
                                .toDate()
                              : null
                          }
                          onChange={handleLotteryDateTimeChange}
                          inputProps={{
                            placeholder: "Lottery Draw Date and Time",
                            value: drawDateTime,
                            readOnly: true,
                          }}
                          isValidDate={isValidDate}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Status
                        </InputLabel>
                        <Select
                          id="status"
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          value={simpleSelect}
                          onChange={handleSimple}
                          inputProps={{
                            name: "status",
                            id: "status",
                            value: formValues.status,
                          }}
                        >
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={true}
                          >
                            Active
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={false}
                          >
                            Inactive
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      {" "}
                      <CustomInput
                        labelText="Total Draw"
                        type="number"
                        id="totalDraw"
                        handleChange={handleChangeTotalDraw}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          value: formValues.totalDraw,
                        }}
                      />
                    </GridItem>
                    {generateTextFields()}
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Total No. of Free ticket"
                        type="number"
                        id="totalNoOfFreeTicket"
                        handleChange={handleChangeTotalSpin}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          min: 0,
                          step: 1,
                          value: formValues.totalNoOfFreeTicket ?? 0,
                          onWheel: (e) => e.target.blur(),
                        }}

                      />
                    </GridItem>
                    {generateFreeTicketSpinTextFields()}
                    {generateFreeTicketSpinPrizeFields()}
                    <GridItem xs={12} sm={12} md={6}>
                      <legend>Maximum Rpm Lottery Wheel</legend>
                      <div className="slider-primary" id="maxRpmLotteryWheel" />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <legend>Decelaration Of Lottery Wheel</legend>
                      <div
                        className="slider-primary"
                        id="decelarationOfLotteryWheel"
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Maximum Number Of Tickets"
                        type="number"
                        id="maxNumOfTickets"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        handleChange={handleChange}
                        inputProps={{
                          type: "number",
                          value: formValues.maxNumOfTickets,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Max Ticket Purchase Limit"
                        type="number"
                        id="maxTktPurchLimit"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        handleChange={handleChange}
                        inputProps={{
                          type: "number",
                          value: formValues.maxTktPurchLimit,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} sx={{ padding: "10px" }}>
                        <Box display="flex" alignItems="flex-end" height="100%">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChange}
                                color="primary"
                                id="LotteryTypeEvent"
                                checked={formValues.LotteryTypeEvent}
                              />
                            }
                            label="Event Lottery"
                          />
                        </Box>
                      </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel className={classes.label}>
                        Instruction
                      </InputLabel>
                      <br />
                      <RichTextEditor
                        value={editorBody}
                        onChange={handleEditorChange}
                        style={{ height: "300px" }}

                      />
                    </GridItem>
                  </GridContainer>
                  {alert}
                  <Button
                    color="rose"
                    className={classes.registerButton}
                    onClick={handleSubmitForm}
                    disabled={showLoader}
                  >
                    {showLoader ? <>Edit Lottery...</> : <>Edit Lottery</>}
                  </Button>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
